<script setup>
defineProps({
  hero: {
    type: Object,
    default: () => ({}),
  },
})
</script>

<template>
  <div class="home-hero row-130-25-b max">
    <div class="section-hero p-top-m-1">
      <div
        :style="{
          backgroundImage: hero.immagine?.responsiveImage?.src
            ? `url(${hero.immagine.responsiveImage.src})`
            : '',
        }"
        class="background-image"
      >
        <!-- eslint-disable vue/no-v-html -->
        <div class="section-left p-top-m-1">
          <div class="text-section">
            <div
              v-if="hero.titolo"
              class="title-base-hero title"
              v-html="hero.titolo"
            />
            <div
              v-if="hero.testo"
              class="text-s-1-b-hero text"
              v-html="hero.testo"
            />
          </div>
          <div class="hero-video-block__content show-for-large">
            <div
              v-if="hero?.videoCover !== ''"
              class="hero-video-block__content__video"
            >
              <VideoYoutube />
              <!-- <Video
                class="is-cover"
                :video-url="hero?.videoCover"
                :video-url-full="hero?.videoFullScreen"
                :loop="true"
                :force-play="true"
                :autoplay="true"
                :muted="true"
                :preload="'auto'"
                :play-in-viewport="true"
              /> -->
            </div>
          </div>
        </div>

        <div v-if="hero.cards.length" class="section-right p-top-m-1">
          <div
            v-for="card in hero.cards"
            :key="card.id"
            class="card"
            :style="{ backgroundColor: card.coloreCard?.hex }"
          >
            <div
              v-if="card.titolo"
              class="card-title title-base2-hero"
              v-html="card.titolo"
            />
            <div
              v-if="card.testo"
              class="card-text text-s-1-hero"
              v-html="card.testo"
            />
            <div v-for="cta in card.cta" :key="cta.id" class="cta">
              <DefaultBtn
                v-if="cta"
                :text="cta?.testo || ''"
                :content="cta?.link || cta?.file?.url || ''"
                :data-evento="cta?.evento || ''"
                class="button-round-1 with-icon"
              />
            </div>
          </div>
        </div>
        <div class="img-container show-for-small">
          <DefaultPicture
            :image="{ custom: hero.immagine?.responsiveImage }"
            :lazy-load="true"
            alt="Istituto Canossiano"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HomeHero',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
